'use strict'

module.exports = caseSensitiveTransform

function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}



//////////////////
// WEBPACK FOOTER
// ./~/hastscript/~/property-information/lib/util/case-sensitive-transform.js
// module id = 200
// module chunks = 35783957827783 204390864267482 254791781388126